import auth from '@/Middlewares/auth.js'
import ResourceRoute from '@/Setup/Routes/ResourceRoute.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'

export const claimRoutes = new RouteGroup(() => {
  return [
    ...new ResourceRoute('claims', {
      show: () => import('./Pages/Show.vue'),
    })
      .permissions({
        show: 'claims.view',
      })
      .only(['show'])
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
